import React from 'react'
import type { LinkButtonProps } from './LinkButton.types'
import './LinkButton.css'

const LinkButton: React.FC<LinkButtonProps> = ({
  children,
  label = 'Link button',
  size = 'md',
  underline = true,
  leftIcon,
  rightIcon,
  className = '',
  darkMode = false,
  previewState,
  disabled,
  type = 'button',
  ...rest
}) => {
  const content = children ?? label
  const isDisabled = disabled || previewState === 'disabled'
  const isPreview = previewState != null

  const classNames = [
    'ds-link-button',
    `ds-link-button--${size}`,
    underline ? 'ds-link-button--underline' : '',
    darkMode ? 'ds-link-button--dark' : '',
    previewState ? `ds-link-button--preview-${previewState}` : '',
    isPreview ? 'ds-link-button--preview' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button
      type={type}
      className={classNames}
      disabled={isDisabled}
      aria-disabled={isDisabled || undefined}
      data-preview-state={previewState}
      {...rest}
    >
      <span className="ds-link-button__inner">
        {leftIcon ? (
          <span className="ds-link-button__icon ds-link-button__icon--left">
            {leftIcon}
          </span>
        ) : null}
        <span className="ds-link-button__label">{content}</span>
        {rightIcon ? (
          <span className="ds-link-button__icon ds-link-button__icon--right">
            {rightIcon}
          </span>
        ) : null}
      </span>
    </button>
  )
}

export default LinkButton
